// extracted by mini-css-extract-plugin
export default {"subTitle":"render-table-cell_subTitle__qkypI","placeHolderShimmer":"render-table-cell_placeHolderShimmer__VHFDJ"};